import {InfoIcon} from '@chakra-ui/icons';
import {Button, Heading, HStack, IconButton} from '@chakra-ui/react';
import Card from 'components/Card/Card';

interface PlayoffSchedulingHeaderProps {
  eventName?: string;
  canSchedule: boolean;
  onScheduleClick: () => void;
  onInfoClick: () => void;
}

export const PlayoffSchedulingHeader: React.FC<PlayoffSchedulingHeaderProps> = ({
                                                                                  eventName,
                                                                                  canSchedule,
                                                                                  onScheduleClick,
                                                                                  onInfoClick,
                                                                                }) => {
  return (
    <Card w="100%">
      <HStack justify="space-between">
        <HStack>
          <Heading>
            {eventName ? `${eventName} - Playoff Scheduling` : 'Playoff Scheduling'}
          </Heading>
          <IconButton
            variant="ghost"
            icon={<InfoIcon/>}
            aria-label="playoff-info"
            onClick={onInfoClick}
          />
        </HStack>
        {canSchedule && (
          <Button colorScheme="blue" onClick={onScheduleClick}>
            Schedule Game
          </Button>
        )}
      </HStack>
    </Card>
  );
};
